/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGenderTrasvesti = createReactComponent("outline", "gender-trasvesti", "IconGenderTrasvesti", [["path", { "d": "M15 20a5 5 0 1 1 0 -10a5 5 0 0 1 0 10z", "key": "svg-0" }], ["path", { "d": "M6 6l5.4 5.4", "key": "svg-1" }], ["path", { "d": "M4 8l4 -4", "key": "svg-2" }]]);

export { IconGenderTrasvesti as default };
//# sourceMappingURL=IconGenderTrasvesti.mjs.map
